// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__eDFcZ","root":"styles_root__17nun"};